// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import jwtDecode from 'jwt-decode'
import { withRouter } from 'react-router'
import connectActions from 'utils/connectActions'

// Actions
import { tokenLogin } from 'actions/actions'
import { AppProgressActivator } from 'atoms/AppProgress'
import ErrorCard from 'atoms/ErrorCard'
import ContentLoader from 'atoms/ContentLoader'

const mapActionsToProps = {
  tokenLoginAction: tokenLogin
}

export default
@connectActions(mapActionsToProps)
@withRouter
class RequestAcceptAction extends Component {
  static propTypes = {
    tokenLoginAction: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    token: PropTypes.string,
  }

  async componentDidMount() {
    const { tokenLoginAction, token, history } = this.props
    try {
      await tokenLoginAction.run({
        params: [token],
        updateComponentOnSuccess: false
      })
      const requestTokenData = jwtDecode(token)
      const { id } = requestTokenData
      history.replace(`/inbox/request/${id}/accept`)
    } catch (error) {
      // do nothing
    }
  }

  render() {
    const { tokenLoginAction } = this.props
    return tokenLoginAction.isFailed ? (
      <ErrorCard
        primary="Error"
        secondary={tokenLoginAction.error.message}
        withHomeAction
      />
    ) : (
      <Fragment>
        <AppProgressActivator />
        <ContentLoader centered />
      </Fragment>
    )
  }
}
